import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { RouterLink, RouterModule } from '@angular/router';
import { IMenusAPIResponse } from '../../models/web/IMenusAPIResponse';
import { OffcanvasService } from '../../services/offcanvas.service';
import { GetMenuWebService } from '../../services/web/get-menus-web.service';
@Component({
	selector: 'app-offcanvas-rigth',
	standalone: true,
	imports: [CommonModule, RouterLink, RouterModule],
	templateUrl: './offcanvas-rigth.component.html'
})
export class OffcanvasRigthComponent implements OnInit {
	@Input({ required: true }) menuOffcanvasRigthDesktop?: IMenusAPIResponse[];
	private offcanvasService = inject(OffcanvasService);
	private _menusApiResource = inject(GetMenuWebService);
	filteredMenusDesktop: IMenusAPIResponse[] = [];
	filteredMenusMobile: IMenusAPIResponse[] = [];
	error: string | null = null;
	isOpen = false;
	ngOnInit() {
		this.offcanvasService.isOffcanvasVisible$.subscribe((isVisible) => (this.isOpen = isVisible));
	}
}
